import { render, staticRenderFns } from "./dialogChat.vue?vue&type=template&id=7ced16b5"
import script from "./dialogChat.vue?vue&type=script&lang=js"
export * from "./dialogChat.vue?vue&type=script&lang=js"
import style0 from "./dialogChat.vue?vue&type=style&index=0&id=7ced16b5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports